import { useLanguage, type Language } from '@/i18n'

const options: { code: Language; label: string }[] = [
  // Each option is written in the language it selects, so neither is ever translated: somebody
  // who cannot read the current language still has to be able to find their own.
  { code: 'en', label: 'English' },
  // Written in the language it selects, so somebody who cannot read the other option can still
  // find their own.
  { code: 'ar', label: 'العربية' },
]

/**
 * English or Arabic.
 *
 * Sits beside the theme toggle, **including on the login screen** — a cashier who cannot read
 * English has to be able to switch before signing in, not after.
 */
export function LanguageSwitch() {
  const { language, set } = useLanguage()

  return (
    <div className="surface-raised inline-flex overflow-hidden rounded-lg border text-sm">
      {options.map((option) => (
        <button
          key={option.code}
          type="button"
          lang={option.code}
          aria-pressed={language === option.code}
          onClick={() => language !== option.code && set(option.code)}
          className={
            language === option.code
              ? 'bg-[var(--accent)] px-3 py-1.5 text-[var(--accent-contrast)]'
              : 'px-3 py-1.5 text-[var(--text-secondary)] hover:bg-[var(--surface-sunken)]'
          }
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
